var ReportingGroup = [
    {
        id : 0,
        reportingGroup: "Government Agencies",
        reportingEntities : [
            {
                reportingEntity: "Bureau of Customs",
                reportingUnits : []
            },
            {
                reportingEntity: "Department of Budget and Management",
                reportingUnits : []
            },
            {
                reportingEntity: "Department of Energy",
                reportingUnits : []
            },
            {
                reportingEntity: "Department of Environment and Natural Resources",
                reportingUnits : [
                    {
                        reportingUnit : "Mines and Geosciences Bureau"
                    }
                ]
            },
            {
                reportingEntity: "National Commission on Indigenous Peoples",
                reportingUnits : []
            }
        ]
    },
    {
        id : 1,
        reportingGroup: "Mining Companies",
        reportingEntities : [
            {
                reportingEntity:  "Carmen Copper Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "AAMPhil Natural Resources Exploration Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Adnama Mining Resources, Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Agata Mining Ventures Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Apex Mining Co., Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Apo Land & Quarry Corporation",
                reportingUnits : [
                    {
                        reportingUnit : "Apo Land & Quarry Corporation (MPSA 013-93-VII)"
                    }
                ]
            },
            {
                reportingEntity:  "Benguet Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "BenguetCorp Nickel",
                reportingUnits : []
            },
            {
                reportingEntity:  "Berong Nickel Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Bohol Limestone Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Cagdianao Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Carrascal Nickel Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Century Peak Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Chromiteking Inc. - Cambayas Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Citinickel Mines and Development Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Concrete Aggregates Corporation",
                reportingUnits : [
                    {
                        reportingUnit : "Concrete Aggregates Corporation (MPSA 032-95-IV)"
                    },
                    {
                        reportingUnit : "Concrete Aggregates Corporation (MPSA 055-96-IV)"
                    }
                ]
            },
            {
                reportingEntity:  "CTP Construction and Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Dolomite Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Eagle Cement Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Emir Mineral Resources Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Eramen Minerals, Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "FCF Minerals Corp.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Filminera Resources Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Gozon Development Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Greenstone Resources Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Hardrock Aggregates, Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Hinatuan Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Holcim Mining and Development Corporation",
                reportingUnits : [
                    {
                        reportingUnit : "Holcim Mining and Development Corporation - Bulacan"
                    },
                    {
                        reportingUnit : "Holcim Mining and Development Corporation - Davao"
                    },
                    {
                        reportingUnit : "Holcim Mining and Development Corporation - La Union"
                    },
                    {
                        reportingUnit : "Holcim Resources and Development Corporation - Lugait, Misamis Oriental"
                    }
                ]
            },
            {
                reportingEntity: "Island Quarry and Aggregates Corporation",
                reportingUnits : [
                    {
                        reportingUnit : "Island Quarry and Aggregates Corporation (MPSA No. 124-98-IVA)"
                    }
                ]
            },
            {
                reportingEntity:  "JLR Construction and Aggregates, Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Krominco, Inc",
                reportingUnits : []
            },
            {
                reportingEntity:  "Lepanto Consolidated Mining Company",
                reportingUnits : []
            },
            {
                reportingEntity:  "Leyte Iron Sand Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Libjo Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "LNL Archipelago Minerals Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Marcventures Mining & Development Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Northern Cement Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "OceanaGold (Philippines), Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Ore Asia Mining and Development Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Oriental Synergy Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Oriental Vision Mining Phils. Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Pacific Nickel Philippines Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Philex Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Philippine Mining Development Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Philsaga Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Platinum Group Metals Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Rapid City Realty and Dev't. Corp.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Republic Cement & Building Materials, Inc",
                reportingUnits : [
                    {
                        reportingUnit : "Republic Cement & Building Materials, Inc - Bulacan"
                    },
                    {
                        reportingUnit : "Republic Cement & Building Materials, Inc - Teresa"
                    },
                    {
                        reportingUnit : "Republic Cement & Building Materials, Inc. - Batangas"
                    }
                ]
            },
            {
                reportingEntity:  "Rio Tuba Nickel Mining Corporation",
                reportingUnits : [
                    {
                        reportingEntity:  "Rio Tuba Nickel Mining Corporation (Metallic)"
                    },
                    {
                        reportingEntity:  "Rio Tuba Nickel Mining Corporation - Gotok Limestone"
                    }
                ]
            },
            {
                reportingEntity:  "Sinosteel Phils H.Y. Mining Corp.",
                reportingUnits : []
            },
            {
                reportingEntity:  "SR Metals, Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Strong Built Mining Development Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Taganito Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Techiron Resources Inc.",
                reportingUnits : []
            },
            {
                reportingEntity:  "Teresa Marble Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Wellex Mining Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Westernshore Nickel Corporation",
                reportingUnits : []
            },
            {
                reportingEntity:  "Zambales Diversified Metals Corp.",
                reportingUnits : []
            }
        ]
    },
    {
        id : 2,
        reportingGroup: "Oil & Gas Companies",
        reportingEntities : [
            {
                reportingEntity: "Chevron Malampaya LLC",
                reportingUnits : []
            },
            {
                reportingEntity: "Cosco Capital, Inc. (formerly Alcorn Gold Resources Corp.)",
                reportingUnits : []
            },
            {
                reportingEntity: "Forum Energy Philippines Corporation",
                reportingUnits : []
            },
            {
                reportingEntity: "Galoc Production Company WLL - Philippine Branch",
                reportingUnits : []
            },
            {
                reportingEntity: "Nido Production (Galoc) Pty. Ltd",
                reportingUnits : []
            },
            {
                reportingEntity: "Oriental Petroleum & Minerals Corporation",
                reportingUnits : []
            },
            {
                reportingEntity: "PNOC Exploration Corporation",
                reportingUnits : []
            },
            {
                reportingEntity: "Shell Philippines Exploration B.V.",
                reportingUnits : []
            },
            {
                reportingEntity: "The Philodrill Corporation",
                reportingUnits : []
            }
        ]
    }
];

export default ReportingGroup;


// WEBPACK FOOTER //
// ./src/constants/ReportingGroup.js